import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/invoiceChange-actions';
import { InvoiceChangeActions } from '../constants';
import { IInvoiceChange } from 'src/types/invoiceChange';

export interface InvoiceChangeState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IInvoiceChange>;
    current: IInvoiceChange | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function invoiceChanges(state: InvoiceChangeState = initialState, action: Actions | any): InvoiceChangeState {
    switch (action.type) {
        case requestType(InvoiceChangeActions.PERSIST_INVOICE_CHANGE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceChangeActions.PERSIST_INVOICE_CHANGE):
            return { ...state, inProgress: false };
        case failureType(InvoiceChangeActions.PERSIST_INVOICE_CHANGE):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceChangeActions.FETCH_INVOICE_CHANGES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta,
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(InvoiceChangeActions.FETCH_INVOICE_CHANGES):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(InvoiceChangeActions.FETCH_INVOICE_CHANGES):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(InvoiceChangeActions.FETCH_INVOICE_CHANGE):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(InvoiceChangeActions.FETCH_INVOICE_CHANGE):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(InvoiceChangeActions.FETCH_INVOICE_CHANGE):
            return { ...state, inProgress: false, error: action.error };
        case requestType(InvoiceChangeActions.DELETE_INVOICE_CHANGE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceChangeActions.DELETE_INVOICE_CHANGE):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IInvoiceChange) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(InvoiceChangeActions.DELETE_INVOICE_CHANGE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
